import type { IconData } from '@stacksjs/iconify-core'

export const computersDevicesElectronicsTapeCassette: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M30.48 6.095H32v19.81h-1.52Zm-4.57 19.81v-1.52h-1.53v1.52H7.62v-1.52H6.1v1.52H1.53v1.52h28.95v-1.52zm1.52-3.05h1.53v1.53h-1.53Zm0-15.24h1.53v1.53h-1.53Zm0 6.1h-1.52V12.2H6.1v1.52H4.58v3.05H6.1v1.52h19.81v-1.52h1.52Zm-16.76 3.05H7.62v-3.05h3.05Zm7.62-1.53h-4.57v-1.52h4.57Zm6.09 1.53h-3.04v-3.05h3.04Zm-1.52 6.09h1.52v1.53h-1.52Zm-13.71-1.52h13.71v1.52H9.15Zm0-13.72h13.71v1.53H9.15Zm-1.53 15.24h1.53v1.53H7.62Zm-4.57 0h1.53v1.53H3.05Zm0-15.24h1.53v1.53H3.05Zm-1.52-3.04h28.95v1.52H1.53ZM0 6.095h1.53v19.81H0Z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default computersDevicesElectronicsTapeCassette
